import divider from './img/PAPER.png';

function Divider() {
    return <div style={{height: "9vw"}}>
        <img style={{width: "100%", height: "auto", position: "absolute", left: 0}} src={divider} alt='divider' />
    </div>
}

export default Divider;